export function generateSrtUrl(primaryServer?: string, password?: string) {
  if ([primaryServer, password].includes(undefined)) {
    return undefined;
  }

  return `${primaryServer}/?passphrase=${password}`;
}
